module.exports = __webpack_public_path__ + "img/webinar-attendance-banner.e5e21231.png";